import { lazy } from "react";
import type { RouteObject } from "react-router";

const CrmIndex = lazy(() => import("./pages/page"));
const Dashboard = lazy(() => import("./pages/dashboard/page"));
const Calendar = lazy(() => import("./pages/calendar/page"));

// Leads
const Leads = lazy(() => import("./pages/leads/page"));
const LeadDetail = lazy(() => import("./pages/leads/[id]/page"));

// Deals
const Deals = lazy(() => import("./pages/deals/page"));
const DealDetail = lazy(() => import("./pages/deals/[id]/page"));

// Contacts
const Contacts = lazy(() => import("./pages/contacts/page"));
const ContactDetail = lazy(() => import("./pages/contacts/[id]/page"));

// Organizations
const Organizations = lazy(() => import("./pages/organizations/page"));
const OrganizationDetail = lazy(() => import("./pages/organizations/[id]/page"));

// Standalone
const Sources = lazy(() => import("./pages/sources/page"));
const LostReasons = lazy(() => import("./pages/lost-reasons/page"));

export const crmRoutes: RouteObject[] = [
  { index: true, Component: CrmIndex },
  { path: "dashboard", Component: Dashboard },
  { path: "calendar", Component: Calendar },

  // Leads
  { path: "leads", Component: Leads },
  { path: "leads/:id", Component: LeadDetail },

  // Deals
  { path: "deals", Component: Deals },
  { path: "deals/:id", Component: DealDetail },

  // Contacts
  { path: "contacts", Component: Contacts },
  { path: "contacts/:id", Component: ContactDetail },

  // Organizations
  { path: "organizations", Component: Organizations },
  { path: "organizations/:id", Component: OrganizationDetail },

  // Standalone
  { path: "sources", Component: Sources },
  { path: "lost-reasons", Component: LostReasons },
];
